import React from "react";
import { FaDraftingCompass, FaVectorSquare, FaCouch } from "react-icons/fa";
import interior3DBanner from "../assets/banner7.jpg";

export default function Interior3DDesign() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            3D Interior Design
          </h2>
          <p className="text-muted fs-6">
            Realistic 3D visualizations to plan, preview, and perfect your interiors.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={interior3DBanner}
            alt="3D Interior Design"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ offers professional 3D interior design services to help you visualize your space before implementation. Our realistic renderings ensure you make confident design decisions, minimizing errors and maximizing aesthetics.
          </p>

          {/* KEY FEATURES */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaDraftingCompass size={22} className="me-3 text-primary" />
              <span>
                Space Planning: Accurate 3D layouts for optimal furniture placement and flow.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaVectorSquare size={22} className="me-3 text-primary" />
              <span>
                Material & Color Visualization: Experiment with textures, finishes, and color palettes before execution.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaCouch size={22} className="me-3 text-primary" />
              <span>
                Interior Concepts: Realistic renderings for kitchens, living areas, offices, and commercial interiors.
              </span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Consultation to understand space, style, and functional requirements.</li>
            <li>Create detailed 3D models with furniture, finishes, lighting, and decor.</li>
            <li>Review renderings with clients and refine until the design is perfect.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Our 3D interior design service bridges imagination and reality, allowing clients to experience their interiors virtually and make informed, confident design choices.
          </p>
        </div>

      </div>
    </div>
  );
}
